<template>
  <fieldset class="bordered-fieldset">
    <legend
      v-if="legend"
      class="bordered-fieldset__legend"
    >
      {{ legend }}
    </legend>
    <slot />
  </fieldset>
</template>

<script>
export default {
  props: {
    legend: {
      type: String,
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .bordered-fieldset
    padding: 1rem
    border: 1px solid $color-form-elements-border
    border-radius: 4px
    &__legend
      font-size: 1rem
      font-weight: bold
      margin-left: -0.5rem
      padding: 0 0.5rem
      margin-bottom: 0
      width: auto
</style>
